import { FieldError } from "react-hook-form/dist/index.ie11";

/**
 * RHF v6 типизирует errors объектных полей (labelInValue-селектов)
 * как DeepMap, но yup при `.object().required()` кладёт FieldError на корень поля.
 * Каст читает message без бойлерплейта в каждом Controller.
 */
export const getFieldError = (error: unknown): string | undefined =>
  (error as FieldError | undefined)?.message;
